/** @typedef {'proposed' | 'prepared' | 'active' | 'paused' | 'completed' | 'cancelled' | 'abandoned'} OrchestrationState */

/** @typedef {'participant' | 'resource'} AllocationTargetType */

/** @typedef {'exclusive' | 'shared'} AllocationMode */

/** @typedef {'held' | 'released'} AllocationHoldState */

export const ORCHESTRATION_STATES = [
  "proposed",
  "prepared",
  "active",
  "paused",
  "completed",
  "cancelled",
  "abandoned",
];

export const CMOE_COMMAND_TYPES = [
  "CreateMatch",
  "GoActive",
  "PauseMatch",
  "ResumeMatch",
  "CompleteMatch",
  "TransferLease",
];
